import axios from 'axios';
import { buildKeyGenerator, setupCache } from 'axios-cache-interceptor';
/**
 * Creates Axios instance pre-configured with cache (using axios-cache-adapter).
 * @param options Configuration options object
 * @returns Pre-configured Axios instance with cache
 */
export function createAxiosWithCache({
  key,
  maxAge
}) {
  return setupCache(axios.create(), {
    generateKey: key && buildKeyGenerator(key),
    ttl: maxAge * 60 * 1000
  });
}
//# sourceMappingURL=createAxiosWithCache.js.map